export default "__VITE_ASSET__c2cbb322__"